/**
 * HM-388 cluster login PIN: Step 3 conferma + auto-redirect.
 * Mostrata per 800ms con icona check verde + nome operatore, poi
 * useNavigate(from) replace. `from` arriva da ?from query param della
 * URL /login?from=/camere (vedi RequireAuth HM-385).
 */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import type { AuthUser } from '../../stores/auth.js';

const ROLE_LABEL: Record<NonNullable<AuthUser['role']>, string> = {
  admin: 'Admin',
  reception: 'Reception',
  housekeeping: 'Housekeeping',
  owner: 'Owner',
};

export function LoginSuccess({ user }: { user: AuthUser }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from') ?? '/';

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(from, { replace: true });
    }, 800);
    return () => clearTimeout(timer);
  }, [navigate, from]);

  return (
    <div className="success-overlay" data-testid="login-success">
      <div className="success-icon">✓</div>
      <div className="success-text">Accesso effettuato</div>
      <div className="success-detail">
        {user.displayName ?? user.email} · {ROLE_LABEL[user.role] ?? user.role}
      </div>
    </div>
  );
}
